import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10756dbb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rl-wrapper" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "grid-wrapper" }
const _hoisted_4 = { class: "sort-wrapper" }
const _hoisted_5 = {
  ref: "gridRef",
  class: "grid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MemberHeader = _resolveComponent("MemberHeader")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_Filtering = _resolveComponent("Filtering")!
  const _component_Search = _resolveComponent("Search")!
  const _component_RewardListSingle = _resolveComponent("RewardListSingle")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MemberHeader),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_SvgIcon, {
        "icon-name": "arrow-left",
        class: "rl-back",
        onClick: $setup.onBackClicked
      }, null, 8, ["onClick"]),
      _createElementVNode("h1", {
        class: "rl-title",
        textContent: _toDisplayString(
    $props.category === 'offer' ? _ctx.$t('birthday-offer') : $props.category === 'reward' ? _ctx.$t('reward') : _ctx.$t('privileges'))
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", null, [
            _createVNode(_component_Filtering, {
              options: $setup.filterOption,
              selected: $setup.filterIndex,
              "onUpdate:selected": _cache[0] || (_cache[0] = ($event: any) => (($setup.filterIndex) = $event)),
              title: _ctx.$t('category')
            }, null, 8, ["options", "selected", "title"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_Search, {
              input: $setup.searchKey,
              "onUpdate:input": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchKey) = $event))
            }, null, 8, ["input"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, i) => {
            return (_openBlock(), _createBlock(_component_RewardListSingle, {
              key: i,
              item: item,
              category: $props.category
            }, null, 8, ["item", "category"]))
          }), 128))
        ], 512)
      ])
    ])
  ], 64))
}